var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_79785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V30H0V0Z",
    fill: "#0B4EA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V15H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8434 34.7625C17.8121 32.8219 12.0371 28.9594 12.0371 21.3375C12.0371 13.7063 12.4121 10.2375 12.4121 10.2375H31.284C31.284 10.2375 31.6496 13.7063 31.6496 21.3375C31.6496 28.9688 25.8746 32.8125 21.8434 34.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8438 33.75C18.1406 31.9688 12.8438 28.425 12.8438 21.4313C12.8438 14.4375 13.1813 11.25 13.1813 11.25H30.5062C30.5062 11.25 30.8344 14.4375 30.8344 21.4313C30.8438 28.4344 25.5469 31.9688 21.8438 33.75Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6312 19.5938C23.6344 19.6125 25.5938 19.65 27.3281 19.0688C27.3281 19.0688 27.2906 19.6969 27.2906 20.4188C27.2906 21.1407 27.3375 21.7688 27.3375 21.7688C25.7438 21.2344 23.7656 21.225 22.6312 21.2344V25.0969H21.0563V21.2344C19.9313 21.225 17.9531 21.2344 16.3594 21.7688C16.3594 21.7688 16.4062 21.1407 16.4062 20.4188C16.4062 19.6875 16.3594 19.0688 16.3594 19.0688C18.0938 19.65 20.0531 19.6125 21.0469 19.5938V17.1657C20.1375 17.1657 18.825 17.2032 17.3344 17.7C17.3344 17.7 17.3812 17.0813 17.3812 16.35C17.3812 15.6282 17.3344 15 17.3344 15C18.825 15.4969 20.1375 15.5438 21.0469 15.5344C21 13.9969 20.55 12.0657 20.55 12.0657C20.55 12.0657 21.4781 12.1313 21.8438 12.1313C22.2188 12.1313 23.1375 12.0657 23.1375 12.0657C23.1375 12.0657 22.6875 13.9969 22.6406 15.5344C23.55 15.5438 24.8625 15.4969 26.3531 15C26.3531 15 26.3063 15.6282 26.3063 16.35C26.3063 17.0813 26.3531 17.7 26.3531 17.7C25.1517 17.3126 23.8932 17.1319 22.6312 17.1657V19.6032V19.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8441 24.6843C19.9785 24.6843 18.9848 27.2625 18.9848 27.2625C18.9848 27.2625 18.4223 26.0437 16.9035 26.0437C15.8723 26.0437 15.1223 26.9531 14.6348 27.8062C16.5098 30.7781 19.5004 32.6156 21.8441 33.75C24.1879 32.625 27.1879 30.7781 29.0535 27.8062C28.566 26.9625 27.816 26.0437 26.7848 26.0437C25.266 26.0437 24.7035 27.2625 24.7035 27.2625C24.7035 27.2625 23.7191 24.6843 21.8441 24.6843Z",
    fill: "#0B4EA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_79785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/sk.dadcf7096adcb7bf34dd1d2e6a095f07.svg";
export { ForwardRef as ReactComponent };